/**
 * Logged-out native mobile welcome: "Continue to Explore" uses `/?showExplore=true`.
 * LoggedOutHomeRoute shows Explore when the param is present; Explore strips it after load (like `openLogin`).
 */
export const SHOW_LOGGED_OUT_EXPLORE_QUERY = 'showExplore';

/**
 * sessionStorage: logged-out native-mobile user chose Explore from welcome (or landed with showExplore).
 * LayoutWrapper shows header + tab bar on `/` when this is set.
 */
export const LOGGED_OUT_MOBILE_EXPLORE_SESSION_KEY = 'gt_logged_out_mobile_explore';

interface LoggedOutNativeWelcomeEligibilityParams {
    hasUser: boolean;
    isMobileViewport: boolean;
    isNativePlatform: boolean;
}

/**
 * Native-only welcome policy:
 * - show Welcome only for logged-out users on phone-sized native iOS/Android
 * - mobile web goes directly to Explore
 */
export function isLoggedOutNativeWelcomeEligible({
    hasUser,
    isMobileViewport,
    isNativePlatform,
}: LoggedOutNativeWelcomeEligibilityParams): boolean {
    return !hasUser && isMobileViewport && isNativePlatform;
}

export function isLoggedOutMobileExplorePersisted(): boolean {
    if (typeof window === 'undefined') return false;
    try {
        return sessionStorage.getItem(LOGGED_OUT_MOBILE_EXPLORE_SESSION_KEY) === '1';
    } catch {
        return false;
    }
}

/** Fired when logged-out user taps Home so shell re-reads sessionStorage (same-path navigation may not re-render). */
export const LOGGED_OUT_MOBILE_EXPLORE_CLEARED_EVENT = 'gt-logged-out-mobile-explore-cleared';
